module.exports = __webpack_public_path__ + "img/财商少年官网-财智大赢家系统01_03.1232e908.jpg";